"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rgbToRgba;
var _addAlpha = _interopRequireDefault(require("../add-alpha"));
var _pushAlpha = _interopRequireDefault(require("../push-alpha"));
var _makeNoDataRgba = _interopRequireDefault(require("../make-no-data-rgba"));
var _safelyConvert = _interopRequireDefault(require("./safely-convert"));
var _quicklyConvert = _interopRequireDefault(require("./quickly-convert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function rgbToRgba({
  old_no_data_value,
  new_no_data_value = null,
  safe = true
} = {}) {
  if (typeof old_no_data_value === "number") {
    if (safe) {
      // @ts-ignore
      return _safelyConvert.default.bind(null, old_no_data_value, new_no_data_value);
    } else {
      const new_no_data_pixel = (0, _makeNoDataRgba.default)(new_no_data_value); // we will reuse this no data pixel
      // @ts-ignore
      return _quicklyConvert.default.bind(null, old_no_data_value, new_no_data_pixel);
    }
  } else {
    if (safe) {
      return _addAlpha.default;
    } else {
      return _pushAlpha.default;
    }
  }
}